
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5fc39eba&scoped=true!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RelatedModulesComponent.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RelatedModulesComponent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5fc39eba!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RelatedModulesComponent.vue"),
  /* scopeId */
  "data-v-5fc39eba",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/grid/RelatedModulesComponent.vue
// module id = 233
// module chunks = 2